import { Component } from 'react';
import Header from '../../Header';
import MessageLink from '../../MessageLink';
import Footer from '../../Footer';
import Lgpd from '../../Lgpd';
import DocumentLink from '../../DocumentLink';
import ErrorBoundary from '../../ErrorHandler/ErrorBoundary';
import InfoComponent from '../InfoComponent';

class CodigoConduta extends Component {
	render() {
		return (
			<div>
				{/* HEADER */}{/* LOGIN */}
				<ErrorBoundary><Header /></ErrorBoundary>
				<main>
					<InfoComponent image={"codigo-etica-estatuto"} page={'codigo-etica-estatuto'}></InfoComponent>
					{/* Content page */}
					<div className="_the-content page-planos pb-10">
						<div className='container'>
							<div className="row justify-content-center">

								<div className="col-md-10">
									<div className="row">
										<ErrorBoundary><DocumentLink fileImg={'../../assets/img/Conduta e Ética_Prancheta 1.png'} url={'ObterCodigoConduta'} /></ErrorBoundary>


									</div>
								</div>
							</div>
						</div>
					</div>

				</main>
				{/* FOOTER */}
				<ErrorBoundary><Footer /></ErrorBoundary>
				{/* Message Link */}
				<ErrorBoundary><MessageLink /></ErrorBoundary>
				{/* LGPD */}
				<ErrorBoundary><Lgpd /></ErrorBoundary>
			</div>
		);
	}
};

export default CodigoConduta;